import { useQuery } from '@tanstack/react-query';

import { getPages } from '../api/build-a-dash-api';
import type { Page } from '../components/PageConfigProvider/types';

export const pageQueryKeys = {
  all: ['pages'] as const,
  lists: () => [...pageQueryKeys.all, 'list'] as const,
  list: (filters: string) => [...pageQueryKeys.lists(), { filters }] as const,
  details: () => [...pageQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...pageQueryKeys.details(), id] as const,
} as const;

export function usePagesQuery(enabled = true) {
  return useQuery<Page[]>({
    queryKey: pageQueryKeys.lists(),
    queryFn: getPages,
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
